import { Dispatch, SetStateAction } from 'react';

import { SectionTitle } from '@/src/components';
import { useRestaurant } from '@/src/hooks';
import { CustomInputField } from '@/src/types';
import { getCustomInputFields, isInputSanitized } from '@/src/utils';
import { Box, Container, TextField } from '@mui/material';

export default function CustomInputs({
  customInputs,
  setCustomInputs,
  setIsRequiredDone,
}: {
  customInputs: Record<string, string>;
  setIsRequiredDone: Dispatch<SetStateAction<boolean>>;
  setCustomInputs: Dispatch<SetStateAction<Record<string, string>>>;
}) {
  const { data: restaurant } = useRestaurant();
  const restaurantFields = getCustomInputFields(
    restaurant?.config?.plCustomInputs,
    restaurant?.config?.plCustomInputsPublic,
    restaurant?.config?.plCustomInputsRequired,
  );
  const countryFields = getCustomInputFields(
    restaurant?.country.config.plCustomInputs,
    restaurant?.country.config.plCustomInputsPublic,
    restaurant?.country.config.plCustomInputsRequired,
  );
  const restAndCountryField: CustomInputField[] = [];
  [...restaurantFields, ...countryFields].forEach(field => {
    if (!restAndCountryField.some(f => f.name === field.name)) {
      restAndCountryField.push(field);
    }
  });

  const onChange = e => {
    const value = e.target.value;
    if (isInputSanitized(value)) {
      const newInputs: Record<string, string> = {
        ...customInputs,
        [e.target.name]: value,
      };
      setCustomInputs(newInputs);
      checkRequired(newInputs);
    }
  };

  const checkRequired = (newInputs: Record<string, string>) => {
    const requiredFields = restAndCountryField.filter(field => field.required);
    const done = requiredFields.every(field => {
      return newInputs[field.name]?.length > 0;
    });
    setIsRequiredDone(done);
  };

  if (!restAndCountryField.length) return null;
  return (
    <Box flex={1} display='flex' flexDirection='row' flexWrap='wrap'>
      {restAndCountryField.map((field, index) => (
        <Box width='100%' display='inline-block' key={index}>
          <SectionTitle title={field.name + (field.required ? ' *' : '')} />
          <Container>
            <TextField
              placeholder={field.name}
              name={field.name}
              fullWidth
              type='text'
              required={field.required}
              value={customInputs?.[field.name] ?? ''}
              onChange={onChange}
            />
          </Container>
        </Box>
      ))}
    </Box>
  );
}
